export class AssetDetailsModel {
    seqNo: number;
    id: string;
    assetName: string;
    address: string;
    model: string;
    barcode: string;
    description: string;
    make: string;
    dateOfPurchase?: Date;
    usefulLife: number;
    maintenanceCycle: number;
    note: string;
    isPrivate: boolean;
    assetStatus: AssetStatusCategories;
    isSelected : boolean;
    areaLevel: string;
    totalRowCount : number;
    isUpdatedAssestDetailsAvailable:boolean;
}

export enum AssetStatusCategories {
    Duplicated = -1,
    Drafted = 0,
    Created = 1,
    NeedToBeApproved = 2,
    SentToTenant = 3,
    TenantCompleted = 4
  }
  